export const environment = {
    production: false,
    OutboundApiUrl: 'https://outbound-call-16788904309.us-central1.run.app',
    callRecordingsApiUrl: 'https://call-recordings-16788904309.us-central1.run.app',
    otherServiceApiUrl: 'https://us-central1-talktact-ee63b.cloudfunctions.net',

    firebaseConfig: {
        apiKey: "AIzaSyAwiqwgElxqcQ_NAO8zKl9squGJMkJuMkw",
        authDomain: "talktact-ee63b.firebaseapp.com",
        projectId: "talktact-ee63b",
        storageBucket: "talktact-ee63b.appspot.com",
        messagingSenderId: "16788904309",
        appId: "1:16788904309:web:edc3ca514ab1208b5a1b3c",
        measurementId: "G-WHVBPT18DW"
    },

    // Price IDs of products on stripe
    priceIds: [
        'price_1QX5QRDH7FShGeEmRDIZzZVb',
        'price_1QX5VmDH7FShGeEmnmHVp3ci'
    ]
};